import { downloadPdf } from '../../../utils/pdf-render';
import exportStyles from './exportStyles';

export const downloadRulesPdf = ( rulesMarkup ) => {
    return dispatch => {
        // Append to the body so we can get matching styling into the pdf
        const offscreenDiv = document.createElement( 'div' );
        offscreenDiv.className = 'offscreen';
        offscreenDiv.insertAdjacentHTML( 'beforeend', rulesMarkup );
        const domNode = document.body.appendChild( offscreenDiv );
        const html = domNode.cloneNode( true ).outerHTML.replace( '<div class="offscreen"', `<div style="${ exportStyles }"` );
        document.body.removeChild( domNode );
        return dispatch( downloadPdf( html, 'rules.pdf' ) );
    };
};
